import React from 'react'

import { Helmet } from 'react-helmet'

import OutlineGrayButton from '../components/outline-gray-button'
import projectStyles from '../style.module.css'
import styles from './home.module.css'

const Home = () => {
  return (
    <div className={styles['container']}>
      <Helmet>
        <title>ACVERA</title>
        <meta
          name="description"
          content="We bring a secure and intuitive platform to set the industry standards for software development."
        />
        <meta property="og:title" content="ACVERA" />
        <meta
          property="og:description"
          content="ACVERA takes its users' attention away from the stress of product development, managing infrastructure and costs and it redirects it towards promoting inventive solutions."
        />
      </Helmet>
      <div className={styles['container01']}>
        <div className={styles['Hero']}>
          <div className={styles['container02']}>
            <div className={styles['Card']}>
              <h1
                id="home"
                className={` ${styles['text']} ${projectStyles['headingOne']} `}
              >
                Quantum Blockchain Software Development Ecosystem.
              </h1>
              <h1
                className={` ${styles['text001']} ${projectStyles['headingOne']} `}
              >
                <span>Choose the best</span>
              </h1>
              <span className={styles['text003']}>
                <span>
                  ACVERA is a quantum blockchain cloud platform for generating
                  software models. It provides a secure, decentralized ecosystem
                  for creating, sharing, and monetizing software models online.
                </span>
              </span>
              <div className={styles['container03']}>
                <div className={styles['container04']}>
                  <div className={styles['container05']}>
                    <a
                      href="#subscribe"
                      className={` ${styles['link']} ${projectStyles['button']} ${projectStyles['buttonSmall']} ${projectStyles['thqLink']} `}
                    >
                      Subscribe
                    </a>
                  </div>
                </div>
                <a href="#from_0_to_hero" className={styles['link01']}>
                  <OutlineGrayButton
                    button="read more"
                    className={` ${styles['component']} ${projectStyles['thqLink']} `}
                  ></OutlineGrayButton>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <img
        id="black_hole"
        alt="black_hole"
        src="/playground_assets/black-hole-6275339-1200h.jpg"
        className={styles['image']}
      />
      <img
        id="home_image"
        alt="image"
        src="/playground_assets/curved5-1000w.jpg"
        className={styles['image01']}
      />
      <div className={styles['container06']}>
        <section className={styles['container07']}>
          <div className={styles['container08']}>
            <h1 id="from_0_to_hero" className={styles['text005']}>
              <span className={styles['text006']}>From zero to hero</span>
            </h1>
            <span className={styles['text007']}>
              <span className={styles['text008']}>
                The highest status people in human history are those that asked
                for nothing and gave everything
              </span>
            </span>
          </div>
          <div className={styles['container09']}>
            <div className={styles['container10']}>
              <span
                className={` ${styles['text009']} ${projectStyles['small']} `}
              >
                <span className={styles['text010']}>
                  &quot;And the reason that I ended up being the Chief Engineer
                  or Chief Designer was not because I wanted to, it was because
                  I couldn&apos;t hire anyone.
                </span>
                <br></br>
                <span></span>
                <br></br>
                <span className={styles['text014']}>
                  Nobody good would join. &quot;
                </span>
                <br></br>
                <span></span>
                <br></br>
                <span className={styles['text018']}>
                  -Elon Musk, CEO &amp; Chief Engineer at SpaceX
                </span>
              </span>
            </div>
            <div className={styles['container11']}>
              <div className={styles['container12']}>
                <h3
                  className={` ${styles['text019']} ${projectStyles['headingTwo']} `}
                >
                  <span className={styles['text020']}>
                    Regardless of the size of your organisation, the costs
                    associated with implementing an IT solution can be
                    startling.
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                </h3>
                <p className={styles['text021']}>
                  <span className={styles['text022']}>
                    Adopting a complex infrastructure for a business can require
                    a significant amount of resources to run, resulting in
                    sizeable expenses - and occasionally mental anguish. Due to
                    budgetary constraints, many entrepreneurs are unable to
                    recruit the right people. As a result, some entrepreneurs
                    are forced to do the unthinkable in order to aquire new
                    skills and grow the business.
                  </span>
                  <br></br>
                  <span></span>
                  <br></br>
                  <span></span>
                  <span>
                    ACVERA is a quantum blockchain cloud computing platform for
                    creating, deploying, and running software solutions without
                    any of the usual security vulnerabilities and high costs of
                    traditional centralized computing. With ACVERA, you can not
                    only design your ideas on-the-go, but also find
                    collaborators to help you bring your ideas to life. Powered
                    by ArisAI for product development, our collaborative
                    platform gives teams the tools to scale their product.
                  </span>
                  <span className={styles['text028']}></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <br></br>
                  <span></span>
                  <br></br>
                  <span>
                    It brings a faster and secure approach that enables a
                    greater spectrum of individuals to bring their ideas to
                    life, while also providing a comprehensive software
                    development platform for sustaining and scaling the product.
                    The platform uses a “sandbox environment”, an advanced
                    version of simulation technology, which allows the user to
                    test the product in prototyping mode. ACVERA provides the
                    world&apos;s first blockchain-based platform for
                    entrepreneurs to develop their own, custom-designed and
                    patented product and run a crowdfunding campaign. It&apos;s
                    a smarter and simpler way to bring your idea to the
                    marketplace and make it a reality.
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div id="intro" className={styles['Gallery']}>
            <div className={styles['GalleryCard']}>
              <img
                alt="image"
                src="/playground_assets/1-1200h.png"
                className={styles['Image02']}
              />
              <h2 className={styles['text101']}>Choose the Platform</h2>
              <span className={styles['text102']}>
                <span className={styles['text103']}>
                  ACVERA is a cloud-based service that provides a full-stack for
                  building enterprise applications in the cloud. Whether
                  it&apos;s building apps, games, solutions for IoT or other
                  platforms, ACVERA gives you instant access to everything you
                  need to deploy your ideas in the world&apos;s leading
                  computing environment.
                </span>
              </span>
            </div>
            <div className={styles['GalleryCard01']}>
              <img
                alt="image"
                src="/playground_assets/3-1200h.png"
                className={styles['image03']}
              />
              <h2 className={styles['text104']}>Describe Your Software</h2>
              <span className={styles['text105']}>
                <span className={styles['text106']}></span>
                <span className={styles['text107']}></span>
                <span className={styles['text108']}></span>
                <span>
                  Whether you are looking for a solution to automate your sales,
                  reduce customer churn or build a better user experience,
                  ArisAI can help you. With our natural language processing and
                  machine learning abilities, we will find the perfect solutions
                  for you in just minutes.
                </span>
              </span>
            </div>
            <div className={styles['GalleryCard02']}>
              <img
                alt="image"
                src="/playground_assets/16-1200h.png"
                className={styles['image04']}
              />
              <h2 className={styles['text110']}>Build Your Team</h2>
              <span className={styles['text111']}>
                ACVERA is the only platform that allows you to work with the
                best talent in the world. Every future-proof business deserves
                the best talent, and we&apos;re here to make sure you get it.
                ArisAI will recommend people with the skills needed for your
                project straight from ACVERA Community Businesses.
              </span>
            </div>
            <div className={styles['GalleryCard03']}>
              <img
                alt="image"
                src="/playground_assets/18-1200h.png"
                className={styles['image05']}
              />
              <h2 className={styles['text112']}>Cooperate Like Never Before</h2>
              <span className={styles['text113']}>
                The ACVERA workspace is the most powerful &amp; easiest way to
                stay connected with your team members. With ACVERA, you can work
                together, brainstorm, or share ideas instantly no matter how far
                they are. No more having to use email or multiple messaging apps
                just to talk with your team - all of your conversations are now
                in one place.
              </span>
            </div>
            <div className={styles['GalleryCard04']}>
              <img
                alt="image"
                src="/playground_assets/24-1200h.png"
                className={styles['image06']}
              />
              <h2 className={styles['text114']}>Intelligent Coding</h2>
              <span className={styles['text115']}>
                ACVERA is the perfect assistant for any software engineer. It
                comes with a complete range of features and tools to make your
                job easier: testing, debugging, and many more. It runs on any
                platform and is compatible with all major languages. With
                ACVERA, you get the best AI coding assistant that will never let
                you down!
              </span>
            </div>
            <div className={styles['GalleryCard05']}>
              <img
                alt="image"
                src="/playground_assets/12-1200h.png"
                className={styles['image07']}
              />
              <h2 className={styles['text116']}>Security at its Finest</h2>
              <span className={styles['text117']}>
                <span>
                  Our approach to developing ArisAI was inspired by the National
                  Security Agency&apos;s reverse-engineering tools.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <span>
                  By combining what we have learned so far with our in-house
                  artificial intelligence security models, ArisAI is able to
                  monitor our users&apos; activity on the platform and secure
                  their projects with state-of-the-art real-time protection.
                </span>
              </span>
            </div>
          </div>
          <div className={styles['Gallery1']}>
            <div className={styles['GalleryCard06']}>
              <img
                alt="image"
                src="/playground_assets/19-1200h.png"
                className={styles['Image08']}
              />
              <h2 className={styles['text120']}>
                Low-Code to No-Code Platform
              </h2>
              <span className={styles['text121']}>
                ACVERA is a low code to no code software development platform
                that provides a simplified experience for business application.
                It&apos;s built on the latest technologies, and is available
                on-premises, in the cloud or hybrid. Inspired by developers and
                for developers, ACVERA makes it easier than ever for
                organizations to launch innovative new applications and get them
                to market quickly.
              </span>
            </div>
            <div className={styles['GalleryCard07']}>
              <img
                alt="image"
                src="/playground_assets/25-1200h.png"
                className={styles['image09']}
              />
              <h2 className={styles['text122']}>An All-Encompasing Platform</h2>
              <span className={styles['text123']}>
                {' '}
                You&apos;ll never go back to your old way of developing software
                again! ACVERA&apos;s intuitive platform offers so many features
                and tools for software developers. Create your wireframes,
                mockups, prototypes, and much more for any type of platform
                without the need for outside help. It&apos;s never been easier
                or more affordable to design, code, and release your prototype
                all by yourself!
              </span>
            </div>
            <div className={styles['GalleryCard08']}>
              <img
                alt="image"
                src="/playground_assets/27-1200h.png"
                className={styles['image10']}
              />
              <h2 className={styles['text124']}>Real-Time Emulator</h2>
              <span className={styles['text125']}>
                As a team, we care about your project and how it delivers value
                to your customers. That&apos;s why we offer ACVERA, a platform
                that allows you to track and trace changes and authors within
                the project. This way, you can focus on making major changes
                without worrying about what else might happen. We offer a device
                emulator which runs on the cloud to help you test changes before
                implementing them.
              </span>
            </div>
            <div className={styles['GalleryCard09']}>
              <img
                alt="image"
                src="/playground_assets/30-1200h.png"
                className={styles['image11']}
              />
              <h2 className={styles['text126']}>Export Your Project</h2>
              <span className={styles['text127']}>
                With ACVERA, you can export all the design assets, code, or make
                your project production ready straight from the platform. You
                can have all the assets on your computer or you can store them
                securely in My Library for quick access. All the assets
                downloaded to your computer are going to be compiled into a file
                with the &quot;.acv&quot; extension.
              </span>
            </div>
            <div className={styles['GalleryCard10']}>
              <img
                alt="image"
                src="/playground_assets/41-1200h.png"
                className={styles['image12']}
              />
              <h2 className={styles['text128']}>
                Publish Straight to Marketplaces
              </h2>
              <span className={styles['text129']}>
                {' '}
                With our easy-to-use platform, you can quickly and easily
                publish your software to the stores without ever leaving the
                ACVERA interface! We make it easy to publish your project to
                three of the top stores, including Google&apos;s Play Store,
                Apple&apos;s App Store, and the ACVERA store. No matter where
                your app lives, ACVERA helps.
              </span>
            </div>
            <div className={styles['GalleryCard11']}>
              <img
                alt="image"
                src="/playground_assets/45-1200h.png"
                className={styles['image13']}
              />
              <h2 className={styles['text130']}>Control Center</h2>
              <span className={styles['text131']}>
                Within Control Center users have access to a variety of tools
                for monitoring the performance of their software, testing their
                infrastructure and security, plus many more
              </span>
            </div>
          </div>
          <div className={styles['Gallery2']}>
            <div className={styles['GalleryCard12']}>
              <img
                alt="image"
                src="/playground_assets/learn%2C%20practice%2C%20discover-1200h.png"
                className={styles['image14']}
              />
              <h2 className={styles['text132']}>Tips &amp; Tricks</h2>
              <span className={styles['text133']}>
                We understand how critical it is to educate our users, which is
                why we have devoted a section on ACVERA platform to serve this
                purpose. Here, users may learn how to utilise the platform and
                how to develop various projects. Additionally, we encourage
                users to provide educational content and engage with the
                community.
              </span>
            </div>
            <div className={styles['container13']}>
              <h2 className={styles['text134']}>
                + Many More for You to Discover
              </h2>
            </div>
          </div>
          <div id="features" className={styles['Features']}>
            <h1 className={styles['text135']}>Some of Our Features</h1>
            <div className={styles['container14']}>
              <div className={styles['FeatureCard']}>
                <img
                  alt="image"
                  src="/playground_assets/natural-language-processing-1000h.png"
                  className={styles['image15']}
                />
                <div className={styles['container15']}>
                  <h2 className={styles['text136']}>
                    Natural Language Processing Models
                  </h2>
                  <span className={styles['text137']}>
                    We have integrated natural language processing models into
                    ArisAI to offer our users the best results for the software
                    they want to develop. We want ArisAI to be the best AI
                    assistant!
                  </span>
                </div>
              </div>
              <div className={styles['FeatureCard1']}>
                <img
                  alt="image"
                  src="/playground_assets/evolution-1000h.png"
                  className={styles['image16']}
                />
                <div className={styles['container16']}>
                  <h2 className={styles['text138']}>
                    Evolutionary Computation
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </h2>
                  <span className={styles['text139']}>
                    Inspired by nature, we are allowing ArisAI to reproduce and
                    generate mutations in order to improve on itself. Using
                    population-based metaheuristic optimization algorithms we
                    can speed up the learning process and reduce costs.
                  </span>
                </div>
              </div>
              <div className={styles['FeatureCard2']}>
                <img
                  alt="image"
                  src="/playground_assets/quantum-computing-1000h.png"
                  className={styles['image17']}
                />
                <div className={styles['container17']}>
                  <h2 className={styles['text140']}>
                    Quantum Blockchain Servers
                  </h2>
                  <span className={styles['text141']}>
                    We provide our users the possibility to choose between
                    traditional high-end servers or quantum blockchain servers
                    to use for their projects.
                  </span>
                </div>
              </div>
              <div className={styles['FeatureCard3']}>
                <img
                  alt="image"
                  src="/playground_assets/cyber-security-1000h.png"
                  className={styles['image18']}
                />
                <div className={styles['container18']}>
                  <h2 className={styles['text142']}>
                    Cyberthreat &amp; Enpoint Protection
                  </h2>
                  <span className={styles['text143']}>
                    With our quantum blockchain servers and ArisAI we are
                    bringing a classical and quantum protection for our users,
                    their projects and the hardware our users decide to register
                    with ACVERA.
                  </span>
                </div>
              </div>
              <div className={styles['FeatureCard4']}>
                <img
                  alt="image"
                  src="/playground_assets/cross-platform1-1000h.png"
                  className={styles['image19']}
                />
                <div className={styles['container19']}>
                  <h2 className={styles['text144']}>
                    Cross-Platform Development
                  </h2>
                  <span className={styles['text145']}>
                    <span>
                      Forget about the sleepless days spent adapting your code
                      to work on different platforms.
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                    <span>
                      ArisAI can modify your software to run on a variety of
                      platforms with little to no intervention.
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div id="our_process" className={styles['Steps']}>
            <h1 className={styles['text148']}>
              <span>Discover Our Process</span>
            </h1>
            <span className={styles['text150']}>
              Bring your idea to the life in a couple of easy steps
            </span>
            <div className={styles['container20']}>
              <div className={styles['Step']}>
                <div className={styles['container21']}>
                  <div className={styles['Line']}></div>
                  <div className={styles['container22']}>
                    <svg viewBox="0 0 1024 1024" className={styles['icon']}>
                      <path d="M634 558q92-64 92-174 0-88-63-151t-151-63-151 63-63 151q0 46 27 96t65 78l36 26v98h172v-98zM512 86q124 0 211 87t87 211q0 156-128 244v98q0 18-12 30t-30 12h-256q-18 0-30-12t-12-30v-98q-128-88-128-244 0-124 87-211t211-87zM384 896v-42h256v42q0 18-12 30t-30 12h-172q-18 0-30-12t-12-30z"></path>
                    </svg>
                  </div>
                  <div className={styles['Line1']}></div>
                </div>
                <div className={styles['container23']}>
                  <h1 className={styles['text151']}>
                    <span>Ideate</span>
                  </h1>
                  <span className={styles['text153']}>
                    <span>Come up with a g</span>
                    <span>reat idea.</span>
                    <span></span>
                  </span>
                </div>
              </div>
              <div className={styles['Step1']}>
                <div className={styles['container24']}>
                  <div className={styles['Line2']}></div>
                  <div className={styles['container25']}>
                    <svg viewBox="0 0 1024 1024" className={styles['icon02']}>
                      <path d="M746 512q26 0 45-18t19-46-19-46-45-18-45 18-19 46 19 46 45 18zM618 342q26 0 45-19t19-45-19-45-45-19-45 19-19 45 19 45 45 19zM406 342q26 0 45-19t19-45-19-45-45-19-45 19-19 45 19 45 45 19zM278 512q26 0 45-18t19-46-19-46-45-18-45 18-19 46 19 46 45 18zM512 128q158 0 271 100t113 242q0 88-63 150t-151 62h-74q-28 0-46 19t-18 45q0 22 16 42t16 44q0 28-18 46t-46 18q-160 0-272-112t-112-272 112-272 272-112z"></path>
                    </svg>
                  </div>
                  <div className={styles['Line3']}></div>
                </div>
                <div className={styles['container26']}>
                  <h1 className={styles['text157']}>
                    <span>Describe</span>
                  </h1>
                  <span className={styles['text159']}>
                    <span>
                      Choose the platform &amp; describe the software you want
                      to develop or what you want to achieve with it to ArisAI.
                    </span>
                    <span></span>
                    <br></br>
                    <span></span>
                  </span>
                </div>
              </div>
              <div className={styles['container27']}>
                <div className={styles['container28']}>
                  <div className={styles['Step2']}>
                    <div className={styles['container29']}>
                      <div className={styles['Line4']}></div>
                      <div className={styles['container30']}>
                        <svg
                          viewBox="0 0 1024 1024"
                          className={styles['icon04']}
                        >
                          <path d="M576 736l96 96 320-320-320-320-96 96 224 224z"></path>
                          <path d="M448 288l-96-96-320 320 320 320 96-96-224-224z"></path>
                        </svg>
                      </div>
                      <div className={styles['Line5']}></div>
                    </div>
                  </div>
                </div>
                <div className={styles['container31']}>
                  <h1 className={styles['text164']}>
                    <span>Tailor</span>
                  </h1>
                  <span className={styles['text166']}>
                    <span>
                      Choose from the results offered by the platform or start
                      from scratch and tailor your project to suit your needs.
                    </span>
                  </span>
                </div>
              </div>
              <div className={styles['Step3']}>
                <div className={styles['container32']}>
                  <div className={styles['Line6']}></div>
                  <div className={styles['container33']}>
                    <svg viewBox="0 0 1024 1024" className={styles['icon07']}>
                      <path d="M480 64c-265.096 0-480 214.904-480 480 0 265.098 214.904 480 480 480 265.098 0 480-214.902 480-480 0-265.096-214.902-480-480-480zM751.59 704c8.58-40.454 13.996-83.392 15.758-128h127.446c-3.336 44.196-13.624 87.114-30.68 128h-112.524zM208.41 384c-8.58 40.454-13.996 83.392-15.758 128h-127.444c3.336-44.194 13.622-87.114 30.678-128h112.524zM686.036 384c9.614 40.962 15.398 83.854 17.28 128h-191.316v-128h174.036zM512 320v-187.338c14.59 4.246 29.044 11.37 43.228 21.37 26.582 18.74 52.012 47.608 73.54 83.486 14.882 24.802 27.752 52.416 38.496 82.484h-155.264zM331.232 237.516c21.528-35.878 46.956-64.748 73.54-83.486 14.182-10 28.638-17.124 43.228-21.37v187.34h-155.264c10.746-30.066 23.616-57.68 38.496-82.484zM448 384v128h-191.314c1.88-44.146 7.666-87.038 17.278-128h174.036zM95.888 704c-17.056-40.886-27.342-83.804-30.678-128h127.444c1.762 44.608 7.178 87.546 15.758 128h-112.524zM256.686 576h191.314v128h-174.036c-9.612-40.96-15.398-83.854-17.278-128zM448 768v187.34c-14.588-4.246-29.044-11.372-43.228-21.37-26.584-18.74-52.014-47.61-73.54-83.486-14.882-24.804-27.75-52.418-38.498-82.484h155.266zM628.768 850.484c-21.528 35.876-46.958 64.746-73.54 83.486-14.184 9.998-28.638 17.124-43.228 21.37v-187.34h155.266c-10.746 30.066-23.616 57.68-38.498 82.484zM512 704v-128h191.314c-1.88 44.146-7.666 87.040-17.28 128h-174.034zM767.348 512c-1.762-44.608-7.178-87.546-15.758-128h112.524c17.056 40.886 27.344 83.806 30.68 128h-127.446zM830.658 320h-95.9c-18.638-58.762-44.376-110.294-75.316-151.428 42.536 20.34 81.058 47.616 114.714 81.272 21.48 21.478 40.362 44.938 56.502 70.156zM185.844 249.844c33.658-33.658 72.18-60.932 114.714-81.272-30.942 41.134-56.676 92.666-75.316 151.428h-95.898c16.138-25.218 35.022-48.678 56.5-70.156zM129.344 768h95.898c18.64 58.762 44.376 110.294 75.318 151.43-42.536-20.34-81.058-47.616-114.714-81.274-21.48-21.478-40.364-44.938-56.502-70.156zM774.156 838.156c-33.656 33.658-72.18 60.934-114.714 81.274 30.942-41.134 56.678-92.668 75.316-151.43h95.9c-16.14 25.218-35.022 48.678-56.502 70.156z"></path>
                    </svg>
                  </div>
                  <div className={styles['Line7']}></div>
                </div>
                <div className={styles['container34']}>
                  <h1 className={styles['text168']}>
                    <span>Deploy</span>
                  </h1>
                  <span className={styles['text170']}>
                    <span>
                      Publish and monetize your project straight from the
                      platform in no time.
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div id="services" className={styles['Services']}>
            <h1 className={styles['text172']}>
              <span>Operating Systems that We Support</span>
              <br></br>
              <span></span>
            </h1>
            <span className={styles['text175']}></span>
            <span className={styles['text176']}>
              We are covering the most used operating systems used, but we are
              looking to expand our capabilities.
            </span>
            <div className={styles['container35']}>
              <div className={styles['FeatureCard5']}>
                <img
                  alt="image"
                  src="/playground_assets/apple-logo-1000h.png"
                  className={styles['image20']}
                />
                <h2 className={styles['text177']}>Apple</h2>
                <span className={styles['text178']}>
                  Majority of MacOS &amp; iOS Releases
                </span>
              </div>
              <div className={styles['FeatureCard6']}>
                <img
                  alt="image"
                  src="/playground_assets/android-1000h.png"
                  className={styles['image21']}
                />
                <h2 className={styles['text179']}>Android</h2>
                <span className={styles['text180']}>
                  Majority of Android Releases
                </span>
              </div>
              <div className={styles['FeatureCard7']}>
                <img
                  alt="image"
                  src="/playground_assets/linux%5B1%5D-1000h.png"
                  className={styles['image22']}
                />
                <h2 className={styles['text181']}>Linux</h2>
                <span className={styles['text182']}>
                  Majority of Linux Distributions
                </span>
              </div>
              <div className={styles['FeatureCard8']}>
                <img
                  alt="image"
                  src="/playground_assets/windows-1000h.png"
                  className={styles['image23']}
                />
                <h2 className={styles['text183']}>Windows</h2>
                <span className={styles['text184']}>
                  Windows XP / Vista / 7 / 8 / 10 / 11
                </span>
              </div>
            </div>
          </div>
          <div id="subscribe" className={styles['Banner']}>
            <div className={styles['container36']}>
              <h1 className={styles['text185']}>
                <span>Be the first to get the latest features</span>
              </h1>
              <span className={styles['text187']}>
                Subscribe to stay up-to-date with our latest releases and win an
                yearly Pro subscription on ACVERA Platform.
              </span>
              <div className={styles['container37']}>
                <input
                  type="text"
                  placeholder="Email here..."
                  className={` ${styles['textinput']} ${projectStyles['input']} `}
                />
                <button
                  className={` ${styles['button']} ${projectStyles['button']} `}
                >
                  Subscribe
                </button>
              </div>
            </div>
            <img
              src="/playground_assets/asset%201.svg"
              className={styles['image24']}
            />
          </div>
          <a href="#home_image" className={styles['link02']}>
            <svg
              viewBox="0 0 1024 1024"
              className={` ${styles['icon09']} ${projectStyles['thqLink']} `}
            >
              <path d="M316 658l-60-60 256-256 256 256-60 60-196-196z"></path>
            </svg>
          </a>
        </section>
      </div>
      <header id="home_header" className={styles['Header']}>
        <img
          id="acvera_logo_header"
          alt="ACVERA_LOGO_header"
          src="/playground_assets/asset%201.svg"
          className={styles['image25']}
        />
        <img
          alt="acvera_logo_alpha"
          src="/playground_assets/group%2018521.svg"
          className={styles['image26']}
        />
        <nav className={styles['Nav']}>
          <a
            href="#intro"
            id="about-page"
            className={` ${styles['link03']} ${projectStyles['thqLink']} `}
          >
            Intro
          </a>
          <a
            href="#features"
            className={` ${styles['link04']} ${projectStyles['thqLink']} `}
          >
            <span>Features</span>
          </a>
          <a
            href="#our_process"
            id="about-page"
            className={` ${styles['link05']} ${projectStyles['thqLink']} `}
          >
            Our Process
          </a>
          <a
            href="#services"
            id="features-page"
            className={` ${styles['link06']} ${projectStyles['thqLink']} `}
          >
            Services
          </a>
        </nav>
        <svg viewBox="0 0 1024 1024" className={styles['icon11']}>
          <path d="M128 554.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM128 298.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM128 810.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667z"></path>
        </svg>
      </header>
      <footer className={styles['Footer']}>
        <div className={styles['Container38']}>
          <img
            alt="logo"
            src="/playground_assets/asset%204.svg"
            className={styles['image27']}
          />
          <span className={styles['text189']}>
            <span>
              © 2021 ACVERA,
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </span>
            <span> All Rights Reserved.</span>
            <span className={styles['text192']}></span>
            <span></span>
          </span>
        </div>
        <div className={styles['LinksContainer']}>
          <div className={styles['Container39']}>
            <div className={styles['Container40']}>
              <span className={styles['text194']}>Product</span>
              <a
                href="#features"
                className={` ${styles['link07']} ${projectStyles['thqLink']} `}
              >
                Features
              </a>
              <a
                href="#services"
                className={` ${styles['link08']} ${projectStyles['thqLink']} `}
              >
                Services
              </a>
              <a
                href="#our_process"
                className={` ${styles['link09']} ${projectStyles['thqLink']} `}
              >
                Our Process
              </a>
            </div>
            <div className={styles['Container41']}>
              <span className={styles['text195']}>Company</span>
              <span className={styles['text196']}>About</span>
              <span className={styles['text197']}>Careers</span>
              <span>Contact</span>
            </div>
          </div>
          <div className={styles['Container42']}>
            <div className={styles['container43']}>
              <span className={styles['text199']}>Support</span>
              <span className={styles['text200']}>Terms of service</span>
              <span className={styles['text201']}>Privacy Policy</span>
              <span>Legal</span>
            </div>
          </div>
        </div>
      </footer>
      <div className={styles['container44']}>
        <div className={styles['container45']}>
          <svg
            viewBox="0 0 731.4285714285713 1024"
            className={styles['icon13']}
          >
            <path d="M678.857 313.143l-166.857 166.857v470.857c0 35.429-28.571 64-64 64s-64-28.571-64-64v-219.429h-36.571v219.429c0 35.429-28.571 64-64 64s-64-28.571-64-64v-470.857l-166.857-166.857c-21.143-21.714-21.143-56 0-77.714 21.714-21.143 56-21.143 77.714 0l130.286 130.286h210.286l130.286-130.286c21.714-21.143 56-21.143 77.714 0 21.143 21.714 21.143 56 0 77.714zM493.714 219.429c0 70.857-57.143 128-128 128s-128-57.143-128-128 57.143-128 128-128 128 57.143 128 128z"></path>
          </svg>
          <div className={styles['container46']}>
            <h1 className={styles['text203']}>Hi</h1>
          </div>
          <span className={styles['text204']}>
            <span>
              For the best experience please visit us using a computer.
            </span>
            <br></br>
            <span></span>
            <br></br>
            <span>Thank you for your understanding!</span>
          </span>
          <svg viewBox="0 0 1024 1024" className={styles['icon15']}>
            <path d="M810 426h86v172h-86v-172zM640 768v-512h86v512h-86zM128 598v-172h86v172h-86zM470 938v-852h84v852h-84zM298 768v-512h86v512h-86z"></path>
          </svg>
          <div className={styles['container47']}>
            <svg
              viewBox="0 0 877.7142857142857 1024"
              className={styles['icon17']}
            >
              <path d="M109.714 731.429v73.143h-64c-5.143 0-9.143-4-9.143-9.143v-9.143h-27.429c-5.143 0-9.143-4-9.143-9.143v-18.286c0-5.143 4-9.143 9.143-9.143h27.429v-9.143c0-5.143 4-9.143 9.143-9.143h64zM109.714 585.143v73.143h-64c-5.143 0-9.143-4-9.143-9.143v-9.143h-27.429c-5.143 0-9.143-4-9.143-9.143v-18.286c0-5.143 4-9.143 9.143-9.143h27.429v-9.143c0-5.143 4-9.143 9.143-9.143h64zM109.714 438.857v73.143h-64c-5.143 0-9.143-4-9.143-9.143v-9.143h-27.429c-5.143 0-9.143-4-9.143-9.143v-18.286c0-5.143 4-9.143 9.143-9.143h27.429v-9.143c0-5.143 4-9.143 9.143-9.143h64zM109.714 292.571v73.143h-64c-5.143 0-9.143-4-9.143-9.143v-9.143h-27.429c-5.143 0-9.143-4-9.143-9.143v-18.286c0-5.143 4-9.143 9.143-9.143h27.429v-9.143c0-5.143 4-9.143 9.143-9.143h64zM109.714 146.286v73.143h-64c-5.143 0-9.143-4-9.143-9.143v-9.143h-27.429c-5.143 0-9.143-4-9.143-9.143v-18.286c0-5.143 4-9.143 9.143-9.143h27.429v-9.143c0-5.143 4-9.143 9.143-9.143h64zM731.429 54.857v841.143c0 30.286-24.571 54.857-54.857 54.857h-475.429c-30.286 0-54.857-24.571-54.857-54.857v-841.143c0-30.286 24.571-54.857 54.857-54.857h475.429c30.286 0 54.857 24.571 54.857 54.857zM877.714 758.857v18.286c0 5.143-4 9.143-9.143 9.143h-27.429v9.143c0 5.143-4 9.143-9.143 9.143h-64v-73.143h64c5.143 0 9.143 4 9.143 9.143v9.143h27.429c5.143 0 9.143 4 9.143 9.143zM877.714 612.571v18.286c0 5.143-4 9.143-9.143 9.143h-27.429v9.143c0 5.143-4 9.143-9.143 9.143h-64v-73.143h64c5.143 0 9.143 4 9.143 9.143v9.143h27.429c5.143 0 9.143 4 9.143 9.143zM877.714 466.286v18.286c0 5.143-4 9.143-9.143 9.143h-27.429v9.143c0 5.143-4 9.143-9.143 9.143h-64v-73.143h64c5.143 0 9.143 4 9.143 9.143v9.143h27.429c5.143 0 9.143 4 9.143 9.143zM877.714 320v18.286c0 5.143-4 9.143-9.143 9.143h-27.429v9.143c0 5.143-4 9.143-9.143 9.143h-64v-73.143h64c5.143 0 9.143 4 9.143 9.143v9.143h27.429c5.143 0 9.143 4 9.143 9.143zM877.714 173.714v18.286c0 5.143-4 9.143-9.143 9.143h-27.429v9.143c0 5.143-4 9.143-9.143 9.143h-64v-73.143h64c5.143 0 9.143 4 9.143 9.143v9.143h27.429c5.143 0 9.143 4 9.143 9.143z"></path>
            </svg>
            <svg viewBox="0 0 1024 1024" className={styles['icon19']}>
              <path d="M704 64l-320 320h-192l-192 256c0 0 203.416-56.652 322.066-30.084l-322.066 414.084 421.902-328.144c58.838 134.654-37.902 328.144-37.902 328.144l256-192v-192l320-320 64-320-320 64z"></path>
            </svg>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Home
